// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.mark-modal {
  position: fixed;
  background: #aaa;
  border: 2px solid #216aff;
  padding: 8px;
  width: 500px;
  z-index: 1000;
  font-family: sans-serif;
  box-shadow: 0 0 12px rgba(0, 0, 0, 0.4);
  font-size: 24px;
  font-weight: bold;
}

.mark-modal h2 {
  background: #216aff;
  color: white;
  margin: -8px -8px 8px -8px;
  padding: 6px 10px;
  font-size: 14px;
}

.mark-modal .preview-list {
  min-height: 100px;
  background: #ccc;
  overflow-y: auto;
  margin-bottom: 10px;
}

.mark-modal .close-btn {
  display: block;
  margin: 0 auto;
}

.preview-list {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 12px;
  max-height: 300px; 
  overflow-y: auto;
  padding: 8px;
  box-sizing: border-box;
}

.preview-block {
  display: flex;
  flex-direction: column;
  align-items: center;
 
  }

.preview-image {
  width: 120px;
  height: 90px;
  object-fit: contain;
}

.preview-image.selected {
  outline: 2px solid dodgerblue;
  outline-offset: 2px;
}

.image-placeholder {
  width: 120px;
  height: 90px;
  background: #eee;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 12px;
  color: #666;
}

.mark-label {
  margin-top: 4px;
  font-size: 14px;
  text-align: center;
}

.ms-markcontrol {
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
}

.image-container {
  position: absolute;
  display: inline-block;
}

.image-container img {
  display: block;
  border-radius: 4px;
}

.anchor-point {
  position: absolute;
  right: -8px;
  top: 50%;
  width:  6px;
  height: 6px;
  border-radius: 50%;
  pointer-events: auto;
  z-index: 10;
}

.dropped-image.selected {
  border-radius: 4px;
  box-sizing: border-box;
}

.tab-container {
  display: flex;
  border-bottom: 1px solid #ccc;
  margin-bottom: 10px;
}

.tab-btn {
  flex: 1;
  padding: 6px 10px;
  background-color: #ccc;
  border: none;
  cursor: pointer;
  font-weight: bold;
  transition: background-color 0.2s;
}

.tab-btn.active {
  background-color: #f4f0ff;
}

.tab-btn:not(.active):hover {
  background-color: #ddd;
}

.close-btn {
  margin: 15px auto 5px;
  padding: 6px 14px;
  font-weight: bold;
  font-size: 14px;
  background-color: #ccc;
  border: none;
  border-radius: 4px;
  cursor: pointer;
  display: block;
  transition: background-color 0.2s;
}

.close-btn:hover {
  background-color: #bbb;
}

.comment-modal {
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  background: #d5d1d1;
  border-radius: 10px;
  padding: 20px 22px;
  width: 340px;
  min-height: 260px;
  box-shadow: 0 8px 30px rgba(0,0,0,0.25);
  border: 1px solid #dadada;
  z-index: 99999999999;
  display: flex;
  flex-direction: column;
  font-family: "Segoe UI", sans-serif;
  resize: none;
}

.line-context-menu {
  background: #fff;
  border: 1px solid #ccc;
  padding: 4px 0;
  box-shadow: 0 4px 10px rgba(0, 0, 0, 0.15);
  font-family: sans-serif;
  font-size: 14px;
  min-width: 160px;
  z-index: 99999999999999;
}

.line-context-menu-item {
  padding: 8px 12px;
  cursor: pointer;
}

.line-context-menu-item:hover {
  background-color: #b6b4c4;
}

.comment-modal button:disabled {
  background: #9fb6ff;
  color: #ffffffaa;       
  cursor: default;
  opacity: 0.6;
  pointer-events: none;
}

.comment-modal-title {
  font-size: 18px;
  font-weight: 600;
  margin-bottom: 12px;
  text-align: center;
  background: #216aff;
  cursor: default;
}

.comment-modal-image {
  max-width: 100%;
  max-height: 120px;
  margin-bottom: 8px;
  object-fit: contain;
  border: 1px solid #eee;
  padding: 4px;
  background: #f9f9f9;
}

.comment-modal-textarea {
  width: 100%;
  min-height: 90px;
  border-radius: 8px;
  background: #efeef3;
  border: 1px solid #cfcfcf;
  padding: 10px 12px;
  font-size: 14px;
  font-family: inherit;
  resize: none;
  outline: none;
  transition: border-color 0.2s ease;
}

.comment-modal-buttons {
  display: flex;
  justify-content: flex-end;
  margin-top: 12px;
}

.comment-btn {
  padding: 6px 14px;
  border: none;
  background: #007bff;
  color: white;
  font-size: 14px;
  border-radius: 4px;
  cursor: pointer;
  transition: background 0.3s ease;
  margin-right: 10px;
}

.comment-btn:hover {
  background: #0056b3;
}

.comment-btn.cancel {
  background: #6c757d;
}

.comment-btn.cancel:hover {
  background: #565e64;
}

.mark-context-menu {
  background: #fff;
  border: 1px solid #ccc;
  padding: 4px 0;
  box-shadow: 0 4px 10px rgba(0, 0, 0, 0.15);
  font-family: sans-serif;
  font-size: 14px;
  min-width: 160px;
  z-index: 99999999999999;
}

.mark-context-menu-item {
  padding: 6px 12px;
  cursor: pointer;
  transition: background 0.2s ease;
}

.mark-context-menu-item:hover {
  background-color: #b6b4c4;
}

.mark-context-menu-item.disabled {
  opacity: 0.5;
  cursor: default;
}

.mark-context-menu-item.disabled:hover {
  background: none;
}`, "",{"version":3,"sources":["webpack://./src/controls/markcontrol/modals/mark-modals.styles.css"],"names":[],"mappings":"AAAA;EACE,eAAe;EACf,gBAAgB;EAChB,yBAAyB;EACzB,YAAY;EACZ,YAAY;EACZ,aAAa;EACb,uBAAuB;EACvB,uCAAuC;EACvC,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,mBAAmB;EACnB,YAAY;EACZ,0BAA0B;EAC1B,iBAAiB;EACjB,eAAe;AACjB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,qCAAqC;EACrC,SAAS;EACT,iBAAiB;EACjB,gBAAgB;EAChB,YAAY;EACZ,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;;EAEnB;;AAEF;EACE,YAAY;EACZ,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,6BAA6B;EAC7B,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,YAAY;EACZ,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,WAAW;AACb;;AAEA;EACE,eAAe;EACf,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,qBAAqB;AACvB;;AAEA;EACE,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,QAAQ;EACR,WAAW;EACX,WAAW;EACX,kBAAkB;EAClB,oBAAoB;EACpB,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,6BAA6B;EAC7B,mBAAmB;AACrB;;AAEA;EACE,OAAO;EACP,iBAAiB;EACjB,sBAAsB;EACtB,YAAY;EACZ,eAAe;EACf,iBAAiB;EACjB,iCAAiC;AACnC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,qBAAqB;EACrB,iBAAiB;EACjB,iBAAiB;EACjB,eAAe;EACf,sBAAsB;EACtB,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,cAAc;EACd,iCAAiC;AACnC;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,eAAe;EACf,QAAQ;EACR,SAAS;EACT,gCAAgC;EAChC,mBAAmB;EACnB,mBAAmB;EACnB,kBAAkB;EAClB,YAAY;EACZ,iBAAiB;EACjB,uCAAuC;EACvC,yBAAyB;EACzB,oBAAoB;EACpB,aAAa;EACb,sBAAsB;EACtB,mCAAmC;EACnC,YAAY;AACd;;AAEA;EACE,gBAAgB;EAChB,sBAAsB;EACtB,cAAc;EACd,0CAA0C;EAC1C,uBAAuB;EACvB,eAAe;EACf,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,iBAAiB;EACjB,eAAe;AACjB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,eAAe;EACf,YAAY;EACZ,oBAAoB;AACtB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,kBAAkB;EAClB,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,kBAAkB;EAClB,mBAAmB;EACnB,sBAAsB;EACtB,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,kBAAkB;EAClB,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;EACf,oBAAoB;EACpB,YAAY;EACZ,aAAa;EACb,kCAAkC;AACpC;;AAEA;EACE,aAAa;EACb,yBAAyB;EACzB,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,YAAY;EACZ,mBAAmB;EACnB,YAAY;EACZ,eAAe;EACf,kBAAkB;EAClB,eAAe;EACf,gCAAgC;EAChC,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,sBAAsB;EACtB,cAAc;EACd,0CAA0C;EAC1C,uBAAuB;EACvB,eAAe;EACf,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,iBAAiB;EACjB,eAAe;EACf,gCAAgC;AAClC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,gBAAgB;AAClB","sourcesContent":[".mark-modal {\r\n  position: fixed;\r\n  background: #aaa;\r\n  border: 2px solid #216aff;\r\n  padding: 8px;\r\n  width: 500px;\r\n  z-index: 1000;\r\n  font-family: sans-serif;\r\n  box-shadow: 0 0 12px rgba(0, 0, 0, 0.4);\r\n  font-size: 24px;\r\n  font-weight: bold;\r\n}\r\n\r\n.mark-modal h2 {\r\n  background: #216aff;\r\n  color: white;\r\n  margin: -8px -8px 8px -8px;\r\n  padding: 6px 10px;\r\n  font-size: 14px;\r\n}\r\n\r\n.mark-modal .preview-list {\r\n  min-height: 100px;\r\n  background: #ccc;\r\n  overflow-y: auto;\r\n  margin-bottom: 10px;\r\n}\r\n\r\n.mark-modal .close-btn {\r\n  display: block;\r\n  margin: 0 auto;\r\n}\r\n\r\n.preview-list {\r\n  display: grid;\r\n  grid-template-columns: repeat(3, 1fr);\r\n  gap: 12px;\r\n  max-height: 300px; \r\n  overflow-y: auto;\r\n  padding: 8px;\r\n  box-sizing: border-box;\r\n}\r\n\r\n.preview-block {\r\n  display: flex;\r\n  flex-direction: column;\r\n  align-items: center;\r\n \r\n  }\r\n\r\n.preview-image {\r\n  width: 120px;\r\n  height: 90px;\r\n  object-fit: contain;\r\n}\r\n\r\n.preview-image.selected {\r\n  outline: 2px solid dodgerblue;\r\n  outline-offset: 2px;\r\n}\r\n\r\n.image-placeholder {\r\n  width: 120px;\r\n  height: 90px;\r\n  background: #eee;\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  font-size: 12px;\r\n  color: #666;\r\n}\r\n\r\n.mark-label {\r\n  margin-top: 4px;\r\n  font-size: 14px;\r\n  text-align: center;\r\n}\r\n\r\n.ms-markcontrol {\r\n  display: flex;\r\n  justify-content: center;\r\n  align-items: center;\r\n  cursor: pointer;\r\n}\r\n\r\n.image-container {\r\n  position: absolute;\r\n  display: inline-block;\r\n}\r\n\r\n.image-container img {\r\n  display: block;\r\n  border-radius: 4px;\r\n}\r\n\r\n.anchor-point {\r\n  position: absolute;\r\n  right: -8px;\r\n  top: 50%;\r\n  width:  6px;\r\n  height: 6px;\r\n  border-radius: 50%;\r\n  pointer-events: auto;\r\n  z-index: 10;\r\n}\r\n\r\n.dropped-image.selected {\r\n  border-radius: 4px;\r\n  box-sizing: border-box;\r\n}\r\n\r\n.tab-container {\r\n  display: flex;\r\n  border-bottom: 1px solid #ccc;\r\n  margin-bottom: 10px;\r\n}\r\n\r\n.tab-btn {\r\n  flex: 1;\r\n  padding: 6px 10px;\r\n  background-color: #ccc;\r\n  border: none;\r\n  cursor: pointer;\r\n  font-weight: bold;\r\n  transition: background-color 0.2s;\r\n}\r\n\r\n.tab-btn.active {\r\n  background-color: #f4f0ff;\r\n}\r\n\r\n.tab-btn:not(.active):hover {\r\n  background-color: #ddd;\r\n}\r\n\r\n.close-btn {\r\n  margin: 15px auto 5px;\r\n  padding: 6px 14px;\r\n  font-weight: bold;\r\n  font-size: 14px;\r\n  background-color: #ccc;\r\n  border: none;\r\n  border-radius: 4px;\r\n  cursor: pointer;\r\n  display: block;\r\n  transition: background-color 0.2s;\r\n}\r\n\r\n.close-btn:hover {\r\n  background-color: #bbb;\r\n}\r\n\r\n.comment-modal {\r\n  position: fixed;\r\n  top: 50%;\r\n  left: 50%;\r\n  transform: translate(-50%, -50%);\r\n  background: #d5d1d1;\r\n  border-radius: 10px;\r\n  padding: 20px 22px;\r\n  width: 340px;\r\n  min-height: 260px;\r\n  box-shadow: 0 8px 30px rgba(0,0,0,0.25);\r\n  border: 1px solid #dadada;\r\n  z-index: 99999999999;\r\n  display: flex;\r\n  flex-direction: column;\r\n  font-family: \"Segoe UI\", sans-serif;\r\n  resize: none;\r\n}\r\n\r\n.line-context-menu {\r\n  background: #fff;\r\n  border: 1px solid #ccc;\r\n  padding: 4px 0;\r\n  box-shadow: 0 4px 10px rgba(0, 0, 0, 0.15);\r\n  font-family: sans-serif;\r\n  font-size: 14px;\r\n  min-width: 160px;\r\n  z-index: 99999999999999;\r\n}\r\n\r\n.line-context-menu-item {\r\n  padding: 8px 12px;\r\n  cursor: pointer;\r\n}\r\n\r\n.line-context-menu-item:hover {\r\n  background-color: #b6b4c4;\r\n}\r\n\r\n.comment-modal button:disabled {\r\n  background: #9fb6ff;\r\n  color: #ffffffaa;       \r\n  cursor: default;\r\n  opacity: 0.6;\r\n  pointer-events: none;\r\n}\r\n\r\n.comment-modal-title {\r\n  font-size: 18px;\r\n  font-weight: 600;\r\n  margin-bottom: 12px;\r\n  text-align: center;\r\n  background: #216aff;\r\n  cursor: default;\r\n}\r\n\r\n.comment-modal-image {\r\n  max-width: 100%;\r\n  max-height: 120px;\r\n  margin-bottom: 8px;\r\n  object-fit: contain;\r\n  border: 1px solid #eee;\r\n  padding: 4px;\r\n  background: #f9f9f9;\r\n}\r\n\r\n.comment-modal-textarea {\r\n  width: 100%;\r\n  min-height: 90px;\r\n  border-radius: 8px;\r\n  background: #efeef3;\r\n  border: 1px solid #cfcfcf;\r\n  padding: 10px 12px;\r\n  font-size: 14px;\r\n  font-family: inherit;\r\n  resize: none;\r\n  outline: none;\r\n  transition: border-color 0.2s ease;\r\n}\r\n\r\n.comment-modal-buttons {\r\n  display: flex;\r\n  justify-content: flex-end;\r\n  margin-top: 12px;\r\n}\r\n\r\n.comment-btn {\r\n  padding: 6px 14px;\r\n  border: none;\r\n  background: #007bff;\r\n  color: white;\r\n  font-size: 14px;\r\n  border-radius: 4px;\r\n  cursor: pointer;\r\n  transition: background 0.3s ease;\r\n  margin-right: 10px;\r\n}\r\n\r\n.comment-btn:hover {\r\n  background: #0056b3;\r\n}\r\n\r\n.comment-btn.cancel {\r\n  background: #6c757d;\r\n}\r\n\r\n.comment-btn.cancel:hover {\r\n  background: #565e64;\r\n}\r\n\r\n.mark-context-menu {\r\n  background: #fff;\r\n  border: 1px solid #ccc;\r\n  padding: 4px 0;\r\n  box-shadow: 0 4px 10px rgba(0, 0, 0, 0.15);\r\n  font-family: sans-serif;\r\n  font-size: 14px;\r\n  min-width: 160px;\r\n  z-index: 99999999999999;\r\n}\r\n\r\n.mark-context-menu-item {\r\n  padding: 6px 12px;\r\n  cursor: pointer;\r\n  transition: background 0.2s ease;\r\n}\r\n\r\n.mark-context-menu-item:hover {\r\n  background-color: #b6b4c4;\r\n}\r\n\r\n.mark-context-menu-item.disabled {\r\n  opacity: 0.5;\r\n  cursor: default;\r\n}\r\n\r\n.mark-context-menu-item.disabled:hover {\r\n  background: none;\r\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
